import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { ArrowRightIcon } from "../../assets/Icon/ArrowRight/ArrowRight";
import { HelpIcon } from "../../assets/Icon/Help/Help";
import { SearchIcon } from "../../assets/Icon/Search/Search";
import Input from "../Input/Input";
import Stack from "../Stack/Stack";
import Text from "../Text/Text";
import {
  FooterContainer,
  FooterLink,
  FooterTag,
  FooterTitle,
  HelpContainer,
  InputContainer,
  SearchTag,
  TextGray,
  Line
} from "./styles";
import { sendEvent } from "src/hooks/analytics";

export function Footer() {
  const actualYear = new Date().getFullYear();
  const [searchParam, setSearchParam] = useState<string>("");
  const location = useLocation();
  const globoId = localStorage.getItem("globoId") || "";
  const providerName = localStorage.getItem("providerName") || "";

  const getPageName = (): string => {
    if (location.pathname === "/success") {
      return "sucesso_na_associacao";
    } else if (location.pathname === "/error") {
      return "erro_na_associacao";
    }
    return "alf_footer";
  };

  const handleSearch = (event: React.FormEvent) => {
    event.preventDefault();
    if (!searchParam) {
      return;
    }

    sendEvent(
      "component_click",
      {
        component_name: "ir_para_ajuda_globo_footer",
        component_type: "search_button",
        component_item_link_redirect: `https://ajuda.globo.com/s/global-search/${searchParam}?`,
        page_name_custom: getPageName(),
        provider_name: providerName
      },
      {
        user_code: globoId,
        user_code_provider: "cadun"
      }
    );

    window.open(
      `https://ajuda.globo.com/s/global-search/${searchParam}?`,
      "_blank"
    );
  };

  const handleHelpContainerClick = () => {
    sendEvent(
      "component_click",
      {
        component_name: "ir_para_ajuda_globo_footer",
        component_type: "button",
        component_item_link_redirect: "https://ajuda.globo.com/s/",
        page_name_custom: getPageName(),
        provider_name: providerName
      },
      {
        user_code: globoId,
        user_code_provider: "cadun"
      }
    );
  };

  return (
    <FooterTag>
      <FooterContainer>
        <Stack spacing={0}>
          <FooterTitle>Precisa de Ajuda?</FooterTitle>
          <Stack spacing={8}>
            <form onSubmit={handleSearch}>
              <Stack
                direction={{ mobile: "column", desktop: "row" }}
                spacing={0}
                justifyContent="space-between"
                alignItems={{ mobile: "flex-start", desktop: "center" }}
              >
                <InputContainer>
                  <Input
                    label="Digite sua dúvida"
                    placeholder="Buscar"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      setSearchParam(e.target.value)
                    }
                    suffix={
                      <SearchTag
                        name="search-icon"
                        aria-label="Buscar"
                        type="submit"
                      >
                        <SearchIcon
                          size={{ mobile: "medium", desktop: "xlarge" }}
                        />
                      </SearchTag>
                    }
                  />
                </InputContainer>
                <HelpContainer
                  target="_blank"
                  href="https://ajuda.globo.com/s/"
                  onClick={handleHelpContainerClick}
                >
                  <Stack direction={"row"} spacing={8}>
                    <HelpIcon />
                    <Text size="small">Acessar Ajuda</Text>
                  </Stack>
                  <ArrowRightIcon />
                </HelpContainer>
              </Stack>
            </form>
          </Stack>
          <Line />
          <Stack
            direction={{ mobile: "column", desktop: "row" }}
            spacing={4}
            justifyContent="space-between"
            alignItems="center"
          >
            <TextGray>
              <Text align={{ mobile: "center", desktop: "left" }} size="small">
                © Copyright 2000-{actualYear} Globo Comunicação e Participações
                S.A
              </Text>
            </TextGray>
            <FooterLink
              target="_blank"
              href="http://www.globo.com/privacidade.html"
            >
              Política de Privacidade
            </FooterLink>
          </Stack>
        </Stack>
      </FooterContainer>
    </FooterTag>
  );
}

export default Footer;
